export function hasRealContent(value: string): boolean {
  if (!value) return false;
  const strippedValue = value.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim();
  return !!strippedValue;
}